import { axiosHelper } from 'Services/AxiosHelper';
import { ApplicationCenterListModel } from 'Models';
import { OnGetApplicationCenterListBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGetApplicationCenterList';

const onGetApplicationCenterList = async (
  params: OnGetApplicationCenterListBodyData
): Promise<ApplicationCenterListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetApplicationCenterList;
